/* tsm-audo.js : gia trong nut ADD TO CART, thanh dinh, loc related (theme TEST Audo) */
(function () {
  'use strict';
  function fmt(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) { return ''; }
  }
  function setPrice(v) {
    if (!v || typeof v.price === 'undefined') return;
    var t = fmt(v.price);
    if (!t) return;
    document.querySelectorAll('[data-tsm-price]').forEach(function (e) { e.textContent = t; });
    document.querySelectorAll('[data-tsm-sticky-atc]').forEach(function (b) { b.disabled = !v.available; });
  }
  document.addEventListener('variant:change', function (e) { setPrice(e.detail && e.detail.variant); });

  function initSticky() {
    var bar = document.querySelector('[data-tsm-audo-sticky]');
    var main = document.querySelector('.page-content--product [data-add-to-cart]');
    if (!bar || !main) return;
    var btn = bar.querySelector('[data-tsm-sticky-atc]');
    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { show(!en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(main);
    }
    btn.addEventListener('click', function () { main.click(); });
  }

  var BLOCK = /\/products\/(lapilli|floraculpt|florasculpt|velours|visoarte|geoform|nordifig)(\?|$|\/)/i;
  function filterRelated() {
    document.querySelectorAll('product-recommendations .grid__item, [data-section-type="recently-viewed"] .grid__item, [id^="RecentlyViewed"] .grid__item').forEach(function (it) {
      var hit = false;
      it.querySelectorAll('a[href*="/products/"]').forEach(function (a) { if (BLOCK.test(a.getAttribute('href'))) hit = true; });
      if (hit || it.querySelector('.grid-product__tag--sold-out')) { it.style.display = 'none'; }
    });
  }
  function initRelated() {
    filterRelated();
    new MutationObserver(filterRelated).observe(document.body, { childList: true, subtree: true });
  }

  function initArrows() {
    var host = document.querySelector('.product__main-photos');
    var slider = host && host.querySelector('.product-slideshow');
    if (!slider || !window.Flickity || host.querySelector('.tsm-audo-arrows')) return;
    var box = document.createElement('div');
    box.className = 'tsm-audo-arrows';
    box.innerHTML = '<button type="button" data-dir="prev" aria-label="Previous"></button><button type="button" data-dir="next" aria-label="Next"></button>';
    host.appendChild(box);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var f = Flickity.data(slider); if (!f) return;
      if (b.getAttribute('data-dir') === 'prev') { f.previous(); } else { f.next(); }
    });
  }


  function initViewBy() {
    var box = document.querySelector('[data-tsm-viewby]');
    var grid = document.querySelector('.collection-grid__wrapper .grid--uniform');
    if (!box || !grid) return;
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var btns = box.querySelectorAll('[data-tsm-cols]');
    if (mobile) { btns[0].textContent = '1'; btns[0].setAttribute('data-tsm-cols', '1'); btns[1].textContent = '2'; btns[1].setAttribute('data-tsm-cols', '2'); }
    var key = mobile ? 'tsm_cols_m' : 'tsm_cols';
    var apply = function (n) {
      var wrap = grid.closest('.collection-grid__wrapper');
      wrap.style.setProperty(mobile ? '--tsm-cols-m' : '--tsm-cols', n);
      btns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-tsm-cols') === String(n)); });
    };
    var saved = null; try { saved = localStorage.getItem(key); } catch (e) {}
    apply(saved || (mobile ? '1' : '3'));
    btns.forEach(function (b) { b.addEventListener('click', function () {
      var n = b.getAttribute('data-tsm-cols'); apply(n); try { localStorage.setItem(key, n); } catch (e) {}
    }); });
  }

  function init() { initSticky(); initRelated(); initViewBy(); setTimeout(initArrows, 600); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
